import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { Environment, EnvironmentExtensionSchema } from './Environment';

export const AWSWorkloadEnvironmentFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AWSWorkload_EnvironmentField',
    component: Environment,
    schema: EnvironmentExtensionSchema,
  }),
);
